define(
    function () {
        let f = function () {};
        if (!window.console) {
            window.console = {
                log:f, info:f, warn:f, debug:f, error:f
            };
        }
        return window.console;
    });



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/console.js